var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SingleNumberFrame',{attrs:{"title":"Number of tails","value":_vm.itemData}})
}
var staticRenderFns = []

export { render, staticRenderFns }